"use client";
import React from "react";
import { BubbleMenuButton } from "../BubbleMenuButton";

interface FloatingButtonProps {
  isInspecting: boolean;
  onToggle: () => void;
}

export const FloatingButton: React.FC<FloatingButtonProps> = ({
  isInspecting,
  onToggle,
}) => {
  return (
    <div className="element-inspector-floating-button-container fixed bottom-6 right-6 z-[10000]">
      <BubbleMenuButton isInspecting={isInspecting} onClick={onToggle} />
    </div>
  );
};
